<template>
  <div class="ruleset">
    <v-card flat="flat" class="nuclear">
      <v-card-title class="nuclear-title">Configuration / Ruleset</v-card-title>
      <v-card-text class="parent">
        <v-card flat="flat">
          <v-card-text class="child">
            <v-data-table
              :headers="headers"
              :items="rulesetItems"
              :hide-default-footer="true"
              :disable-pagination="true"
            >
              <template v-slot:item.riskrating="{ item }">
                <div v-if="item.riskrating == 1" class="riskrate">
                  <font-awesome-icon
                    class="risk_rating critical"
                    icon="circle"
                  />
                </div>
                <div v-if="item.riskrating == 2" class="riskrate">
                  <font-awesome-icon class="risk_rating high" icon="circle" />
                </div>
                <div v-if="item.riskrating == 3" class="riskrate">
                  <font-awesome-icon class="risk_rating medium" icon="circle" />
                </div>
                <div v-if="item.riskrating == 4" class="riskrate">
                  <font-awesome-icon class="risk_rating low" icon="circle" />
                </div>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
export default {
  data() {
    return {
      headers: [
        { text: "TITLE", align: "left", value: "title", sortable: false },
        {
          text: "DESCRIPTION",
          align: "left",
          value: "description",
          sortable: false
        },
        {
          text: "RISK RATING",
          align: "center",
          value: "riskrating",
          sortable: false
        }
      ]
    };
  },
  mounted() {
    this.$store.dispatch("getAllRuleset");
  },
  computed: {
    rulesetItems() {
      return this.$store.state.ruleset.all;
    }
  }
};
</script>
